module.exports = __webpack_public_path__ + "static/freelance-c003c4fef88e0f92dfc2898c231c23b7.png";